"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Moon = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "moon" },
            react_1.default.createElement("path", { id: "Icon", d: "M21.9548 12.9564L22.9504 13.0508C22.9949 12.5817 22.7058 12.1451 22.2564 12.0029C21.8071 11.8608 21.3195 12.0517 21.0861 12.4611L21.9548 12.9564ZM11.0443 2.04492L11.5395 2.91371C11.9489 2.68033 12.1398 2.19275 11.9977 1.7434C11.8556 1.29404 11.4191 1.0049 10.9499 1.04939L11.0443 2.04492ZM21.0861 12.4611C19.8798 14.5771 17.6055 16.0001 15 16.0001V18.0001C18.3528 18.0001 21.2761 16.1662 22.8236 13.4516L21.0861 12.4611ZM15 16.0001C11.134 16.0001 8 12.8661 8 9.00008H6C6 13.9706 10.0294 18.0001 15 18.0001V16.0001ZM8 9.00008C8 6.39442 9.4232 4.11992 11.5395 2.91371L10.5491 1.17613C7.83414 2.72358 6 5.64701 6 9.00008H8ZM3 11.9998C3 7.31999 6.57266 3.47339 11.1387 3.04046L10.9499 1.04939C5.36684 1.57875 1 6.27874 1 11.9998H3ZM12 20.9998C7.02944 20.9998 3 16.9704 3 11.9998H1C1 18.075 5.92487 22.9998 12 22.9998V20.9998ZM20.9593 12.8619C20.5261 17.4276 16.6796 20.9998 12 20.9998V22.9998C17.7208 22.9998 22.4206 18.6335 22.9504 13.0508L20.9593 12.8619Z" }))));
};
exports.default = Moon;
